angular.module("vgresiduos").controller("DnitReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "declaracoes/dnit");
		};
	}
]);
